module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: {
      'critter': true, 'active': _vm.showCreator
    },
    attrs: {
      "data-categories": _vm.categories
    }
  }, [_c('picture', [(_vm.getWebpImage) ? _c('source', {
    attrs: {
      "srcset": _vm.getWebpImage,
      "type": "image/webp"
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "critter__image",
    attrs: {
      "alt": "",
      "src": _vm.getImage,
      "loading": "lazy",
      "width": "100",
      "height": "100"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "critter__info"
  }, [_c('ul', {
    staticClass: "link-list"
  }, [_c('li', [_c('a', {
    staticClass: "critter__name",
    attrs: {
      "target": "_blank",
      "href": _vm.creator.twitterHandle,
      "rel": "external"
    }
  }, [_vm._v(_vm._s(_vm.creator.name))])]), _vm._v(" "), (_vm.creator.websiteUrl) ? _c('li', [_c('a', {
    staticClass: "critter__shop",
    attrs: {
      "target": "_blank",
      "href": _vm.creator.websiteUrl,
      "rel": "external"
    }
  }, [_vm._v("Website")])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "category-list"
  }, [_vm._v(_vm._s(_vm.categories))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ed8b601!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreatorDetail.vue
// module id = 755
// module chunks = 0